<div class="input-group input-group-sm">
  <input [id]="getId(input)" [attr.type]="input.MainElementList[0].Type" class="col q-input-border q-bo" aria-label="Small"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="setClass(input)">
  <div *ngFor="let button of input?.MainElementList?.slice(1)" class="input-group-append">
    <button *ngIf="button.Type === 'BUTTON'" class="q-btn q-bo q-main p-0" (click)="OnButtonClick(button, ModalAdmin);"
            [title]="button?.Tooltip ? button?.Tooltip : ''">
      <i class="{{button.Src}}"></i>
    </button>
  </div>
  <button class="q-btn q-bo q-main p-0"
          title="Envoyer les identifiants par mail"
          (click)="SendMail()"
          [disabled]="!abledMail">
    <i [ngClass]="[sendingMail ? 'fas fa-spin fa-pulse fa-spinner' :'fas fa-paper-plane']"></i>
  </button>
  <button class="q-btn q-bo q-main p-0"
          title="Accéder à l'extranet"
          (click)="OpenPortail()"
          [disabled]="!abledMail">
    <i class="fas fa-sign-in-alt"></i>
  </button>

</div>


<ng-template #ModalAdmin let-modalAdmin>
  <div class="modal-header">
    <h5 class="modal-title q-bold q-c-main" id="ModalTitle">Administration Accès Extranet</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalAdmin.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <q-acces-portail class="h-100 w-100" [idPersonne]="model.IdDonneeFils" (save)="CloseModalAdmin($event, modalAdmin)" (cancel)="CloseModalAdmin($event, modalAdmin)"></q-acces-portail>
  </div>
</ng-template>
